/**
 * Laedt einen Screenshot ueber die API-Facade (Header-Auth) als Object-URL.
 */

import { useEffect, useState } from "react"
import { api } from "@/services/api"

export function useAuthImage(reportId: number, screenshotId: number): string | null {
  const [url, setUrl] = useState<string | null>(null)

  useEffect(() => {
    let aktiv = true
    let objectUrl: string | null = null
    void api.reports.screenshots.dateiUrl(reportId, screenshotId).then((u) => {
      objectUrl = u
      if (aktiv) setUrl(u)
      else URL.revokeObjectURL(u)
    })
    return () => {
      aktiv = false
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [reportId, screenshotId])

  return url
}
